import _ from 'lodash'

const initState = {
  visitedViews: [],
  cachedViews: [],
}

export const state = Object.assign({}, _.cloneDeep(initState))

export const mutations = {
  UPDATE_VISITED_VIEWS(state: any, views: any) {
    const filteredViews = state.visitedViews.filter((el: any) => el.addMenu === true)
    state.visitedViews = [...views, ...filteredViews]
  },

  ADD_VISITED_VIEW(state: any, view: any) {
    if (state.visitedViews.some((v: any) => v.path === view.path)) return

    state.visitedViews.push(
      Object.assign({}, view, {
        title: view.meta.title || 'no-name',
      })
    )
  },

  ADD_CACHED_VIEW(state: any, view: any) {
    if (view.name === null) return
    if (state.cachedViews.includes(view.name)) return
    if (!view.meta.noCache) {
      state.cachedViews.push(view.name)
    }
  },

  DEL_VISITED_VIEW(state: any, view: any) {
    for (const [i, v] of state.visitedViews.entries()) {
      if (v.path === view.path) {
        state.visitedViews.splice(i, 1)
        break
      }
    }
  },

  DEL_CACHED_VIEW(state: any, view: any) {
    if (view.name === null) return
    const index = state.cachedViews.indexOf(view.name)
    index > -1 && state.cachedViews.splice(index, 1)
  },

  DEL_OTHERS_VISITED_VIEWS(state: any, view: any) {
    state.visitedViews = state.visitedViews.filter((v: any) => {
      return v.meta.affix || v.path === view.path
    })
  },

  DEL_OTHERS_CACHED_VIEWS(state: any, view: any) {
    if (view.name === null) return
    const index = state.cachedViews.indexOf(view.name)
    if (index > -1) {
      state.cachedViews = state.cachedViews.slice(index, index + 1)
    } else {
      // if index = -1, there is no cached tags
      state.cachedViews = []
    }
  },

  DEL_ALL_VISITED_VIEWS(state: any, payload: any) {
    // keep affix tags
    const affixTags = state.visitedViews.filter((tag: any) => tag.meta.affix)
    state.visitedViews = affixTags
  },

  DEL_ALL_CACHED_VIEWS(state: any, payload: any) {
    state.cachedViews = []
  },

  UPDATE_VISITED_VIEW(state: any, view: any) {
    for (let v of state.visitedViews) {
      if (v.path === view.path) {
        v = Object.assign(v, view)
        break
      }
    }
  },

  resetState(state: any) {
    Object.assign(state, _.cloneDeep(initState))
  },
}

export const actions = {
  updateViews({ commit }: any, views: any) {
    commit('UPDATE_VISITED_VIEWS', views)
  },

  addView({ commit }: any, view: any) {
    commit('ADD_VISITED_VIEW', view)
    commit('ADD_CACHED_VIEW', view)
  },

  addVisitedView({ commit }: any, view: any) {
    commit('ADD_VISITED_VIEW', view)
  },

  delView({ commit }: any, view: any) {
    commit('DEL_VISITED_VIEW', view)
    commit('DEL_CACHED_VIEW', view)
  },

  delCachedView({ commit }: any, view: any) {
    commit('DEL_CACHED_VIEW', view)
  },

  delOthersViews({ commit }: any, view: any) {
    commit('DEL_OTHERS_VISITED_VIEWS', view)
    commit('DEL_OTHERS_CACHED_VIEWS', view)
  },

  delAllViews({ commit }: any, payload: any) {
    commit('DEL_ALL_VISITED_VIEWS')
    commit('DEL_ALL_CACHED_VIEWS')
  },

  delAllCachedViews({ commit }: any, payload: any) {
    commit('DEL_ALL_CACHED_VIEWS')
  },

  updateVisitedView({ commit }: any, view: any) {
    commit('UPDATE_VISITED_VIEW', view)
  },

  resetState({ commit }: any) {
    commit('resetState')
  },
}

export const getters = {
  visitedViewList(state: any) {
    return state.visitedViews
  },
}
